<template>
  <div class="relative" :class="SSectionVerticalMarginClasses">
    <TContainer :mobile-full="mobileFull" :desktop-full="desktopFull">
      <TGrid>
        <div
          class="col-span-12"
          :class="{
            'lg:col-span-8': !fullWidth,
            'lg:col-start-3': !fullWidth && centered,
          }"
        >
          <TSeparator
            v-if="hasSeparator"
            :class="SSectionSeparatorMarginClasses"
          />

          <TTitle
            v-if="title && title.length > 0"
            :tag="titleTag"
            :size="SSectionTitleSize"
            :class="{ 'text-center': centered }"
            :classes="SSectionTitleClasses"
            :leading="SSectionTitleLeading"
          >
            {{ title }}
          </TTitle>

          <slot />
        </div>
      </TGrid>
    </TContainer>

    <slot name="no-container" />
  </div>
</template>

<script setup lang="ts">
import type { propsInterface as TTitlePropsInterface } from '~~/modules/design-system/components/t-title/index.vue'
import {
  SSectionVerticalMarginClasses,
  SSectionSeparatorMarginClasses,
} from './constants'
import { sectionTitle } from '~~/modules/design-system/utils/components/t-title'

export interface propsInterface {
  title?: string
  titleTag?: TTitlePropsInterface['tag']
  titleClasses?: TTitlePropsInterface['classes']
  hasSeparator?: boolean
  fullWidth?: boolean
  mobileFull?: boolean
  desktopFull?: boolean
  centered?: boolean
}

const props = withDefaults(defineProps<propsInterface>(), {
  titleTag: sectionTitle.tag,
  hasSeparator: true,
  fullWidth: true,
  mobileFull: false,
  desktopFull: false,
  centered: false,
})

const SSectionTitleSize = sectionTitle.size
const SSectionTitleClasses = props.titleClasses || sectionTitle.classes
const SSectionTitleLeading = sectionTitle.leading
</script>
